import { VariantProps, cva } from 'class-variance-authority'
import * as React from 'react'
import { cn } from 'src/lib/utils'

const inputVariants = cva(
  'flex w-full rounded-md bg-secondary-gray px-4 py-2 font-evogria text-sm text-light-gray file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-mushroom focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      variant: {
        default: 'bg-secondary-gray text-light-gray',
        error:
          'bg-error-bg text-error-2 placeholder:text-error-2/60 border-0 outline-none ring-0 focus-visible:outline-none focus-visible:ring-0',
        success: 'bg-secondary-gray text-light-gray',
      },
      size: {
        default: 'h-12 px-2 py-2 text-sm',
        sm: 'h-9 px-3 text-sm',
        lg: 'h-14 px-6 text-sm',
        xl: 'h-[78px] px-7 text-base',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
)

export type InputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> & VariantProps<typeof inputVariants>

const errorOnlyClasses =
  'bg-error-bg text-error-2 placeholder:text-error-2/60 border-0 outline-none ring-0 focus-visible:outline-none focus-visible:ring-0'

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, variant, size, ...props }, ref): React.ReactElement => {
    const variantClasses = inputVariants({ variant, size })
    return (
      <input
        type={type}
        className={variant === 'error' ? cn(variantClasses, className, errorOnlyClasses) : cn(variantClasses, className)}
        ref={ref}
        {...props}
      />
    )
  },
)
Input.displayName = 'Input'

export { Input, inputVariants }
